export default {"src":"/_next/static/media/icon-five.3ee343fd.svg","height":22,"width":22};